import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

function withApp<T>(WrapperComponent: React.ElementType) {
  function App(props: T) {
    const app = useSelector((state: any) => state.app.data);
    if (!app || !app?._id) {
      return <Navigate to="/app" />;
    }
    return (
      <>
        <WrapperComponent {...props} />
      </>
    );
  }
  return App;
}
export default withApp;
